import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem } from "@material-ui/core";
import React, {Component} from "react";

import ErrorMessageDialog from "../ui/ErrorMessageDialog";

import api from "../api.js"

/**
 * item_shops
 * hideNoShop - скрыть позицию "Нет магазина"
 * hideShops - список магазинов которые стоит исключить из списка.
 * 
 * onSelectClick(shop)
 * onCancelClick()
 */

class SelectShopDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selected: undefined,
            shops: [],
        }

        this.handle_error = this.handle_error.bind(this)
        this.handle_onSelectClick = this.handle_onSelectClick.bind(this)
    }

    async componentDidMount() {
        await this.update().catch(this.handle_error)
    }

	async update() {
        const response = await api.shops.list()
        let shops = this.props.hideShops ? 
            response.shops.filter(shop => !this.props.hideShops.find(sf => sf.id == shop.id))
        :
            response.shops
        this.setState({shops: shops})
    }

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}	

    handle_onSelectClick(shop) {
        if (typeof this.props.onSelectClick === "function") {
            this.props.onSelectClick(shop.id !== -1 ? shop : undefined)
        }                            
    }

    render() {

        let item_shops = this.props.item_shops || []
        let other_shops = this.state.shops.filter(shop => !item_shops.find(s => s.id == shop.id))

        let dividerCounter = -1

        const show_no_shop = () => {
            if (this.props.hideNoShop) {
                return undefined
            }
            dividerCounter++
            return <React.Fragment>
                {dividerCounter > 0 && <Divider/>}
                <ListItem
                    button
                    selected = {this.state.selected ? this.state.selected.id === -1 : false }
                    onClick = {e => {
                        e.stopPropagation()
                        this.setState({selected: {id: -1, name: "Магазин не указан"}})
                    }}
                    onDoubleClick = {e => {
                        e.stopPropagation()
                        this.handle_onSelectClick({id: -1, name: "Магазин не указан"})
                    }}
                >
                    Нет магазина
                </ListItem>
            </React.Fragment>
        }

        const show_item_shops = () => {
            if (!item_shops.length) {
                return undefined
            }
            dividerCounter++
            return <React.Fragment>
                {dividerCounter > 0 && <Divider/>}
                {item_shops.map((shop, n) => <ListItem 
                    key = {n}
                    button
                    selected = {this.state.selected ? this.state.selected.id === shop.id : false}
                    onClick = {e => {
                        e.stopPropagation()
                        this.setState({selected: shop})
                    }}
                    onDoubleClick = {e => {
                        e.stopPropagation()
                        this.handle_onSelectClick(shop)
                    }}
                >
                    {shop.name}
                </ListItem>)}
            </React.Fragment>
        }

        const show_other_shops = () => {
            if (!other_shops.length) {
                return undefined
            }
            dividerCounter++
            return <React.Fragment>
                {dividerCounter > 0 && <Divider/>}
                {other_shops.map((shop, n) => <ListItem 
                    key = {n}
                    button
                    selected = {this.state.selected ? this.state.selected.id === shop.id : false}
                    onClick = {e => {
                        e.stopPropagation()
                        this.setState({selected: shop})
                    }}
                    onDoubleClick = {e => {
                        e.stopPropagation()
                        this.handle_onSelectClick(shop)
                    }}
                >
                    {shop.name}
                </ListItem>)}
            </React.Fragment>
        }

        return <Dialog open = {true} fullWidth = {true}>
            <DialogTitle>Выбрать магазин</DialogTitle>
            <DialogContent>
                <List>
                    {show_no_shop()}
                    {show_item_shops()}
                    {show_other_shops()}
                </List>
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!this.state.selected}
                    onClick = {e => {
                        e.stopPropagation()
                        this.handle_onSelectClick(this.state.selected)
                    }}
                >
                    Выбрать
                </Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >
                    Отмена
                </Button>
            </DialogActions>
        </Dialog>
    }

}

export default SelectShopDialog